import {mapState, mapGetters, mapActions} from 'vuex'
import store from './vuex';

if (!window.myLabMixins) {
  window.myLabMixins = [];
}

window.myLab = new Vue({
    el: '#myLab-app',
    store,
    mixins: myLabMixins,
    data: {
        environment: 'production',
        selected_account: {},
        selected_accounts: [],
        phoneModal: null
    },
    computed: {
        ...mapState('user', ['auth_user', 'visible_user', 'user_accounts']),
        ...mapGetters('user', ['hasRole', 'hasIndustry', 'hasStatus', 'hasPhone']),
        production () {
            return this.environment.toLowerCase() == 'production'
        },
        visible_user_changed () {
            return this.auth_user ? this.auth_user.user_id != this.visible_user.user_id : false
        }
    },
    methods: {
        changeVisibleUser () {
            this.$refs.visibleUserPicker.showSelector()
        }
    },
    mounted() {
        const environment = this.$el.getAttribute('environment')
        const selected_account = this.$el.getAttribute('selected_account')
        const selected_accounts = this.$el.getAttribute('selected_accounts')
        const auth_user = this.$el.getAttribute('auth_user')
        const visible_user = this.$el.getAttribute('visible_user')
        const user_accounts = this.$el.getAttribute('user_accounts')

        if (environment != '') {
            this.environment = environment;
        }
        if (selected_account != '') {
            this.selected_account = JSON.parse(selected_account)
        }
        if (selected_accounts != '') {
            this.selected_accounts = JSON.parse(selected_accounts)
        }
        if (auth_user != '') {
            this.$store.commit('user/setAuthUser', JSON.parse(auth_user))
        }
        if (visible_user != '') {
            this.$store.commit('user/setVisibleUser', JSON.parse(visible_user))
        }
        if (user_accounts != '') {
            this.$store.commit('user/setUserAccounts', JSON.parse(user_accounts))
        }

        this.$el.removeAttribute('environment')
        this.$el.removeAttribute('selected_account')
        this.$el.removeAttribute('selected_accounts')
        this.$el.removeAttribute('auth_user')
        this.$el.removeAttribute('visible_user')
        this.$el.removeAttribute('user_accounts')

        this.phoneModal = $(this.$refs.phoneModal);
        $('body').append(this.phoneModal);
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.vue.js